module.exports = __webpack_public_path__ + "static/media/top.ccf8c969.png";